import { AreaType, useAreaPageData } from "@tether-web-portal/hooks/useAreaPageData";
import { DeviceType } from "@tether-web-portal/types/DeviceType";
import { OutsideWithReading } from "@tether-web-portal/types/OutsideWithReading";
import { RoomLocationWithReading } from "@tether-web-portal/types/RoomLocation";
import { useMemo } from "react";

export type ChildRoomLocationsMap = Partial<Record<DeviceType, RoomLocationWithReading[]>>;

export const useChildRoomLocationsMap = (roomLocation: RoomLocationWithReading | OutsideWithReading) => {
  const roomId = "roomId" in roomLocation ? roomLocation.roomId : undefined;
  const { roomLocations } = useAreaPageData("room" as AreaType, roomId ?? "", {
    enabled: Boolean(roomId),
  });
  const childRoomLocations = useMemo<ChildRoomLocationsMap>(
    () =>
      (roomLocations ?? [])
        .filter((child) => child.parentRoomLocationId === roomLocation.id && child.device)
        .reduce((record, child) => {
          const deviceType = child.device.type as DeviceType;
          record[deviceType] = (record[deviceType] || []).concat(child);
          return record;
        }, {} as ChildRoomLocationsMap),
    [roomLocations, roomLocation.id],
  );
  return childRoomLocations;
};
